/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        const dateField = document.getElementById('84179-text-3');
        
        if (dateField) {
            console.log('Campo de fecha encontrado, aplicando máscara...');
            
            // Configurar el campo
            dateField.setAttribute('placeholder', 'MM/DD/YYYY');
            dateField.setAttribute('maxlength', '10');
            
            // Aplicar estilos directamente
            dateField.style.color = '#00398b';
            
            // Crear e inyectar CSS para placeholder
            const style = document.createElement('style');
            style.textContent = `
                #84179-text-3::placeholder {
                    color: #00398b !important;
                    opacity: 1 !important;
                }
            `;
            document.head.appendChild(style);
            
            // Función para aplicar máscara automática
            function applyMask(value) {
                // Solo números
                value = value.replace(/\D/g, '');
                
                // Aplicar formato MM/DD/YYYY automáticamente
                if (value.length >= 2) {
                    value = value.substring(0,2) + '/' + value.substring(2);
                }
                if (value.length >= 5) {
                    value = value.substring(0,5) + '/' + value.substring(5,9);
                }
                
                return value;
            }
            
            // Función de validación (solo para feedback visual)
            function isValidDate(dateString) {
                if (dateString.length !== 10) return false;
                
                const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
                if (!regex.test(dateString)) return false;
                
                const parts = dateString.split('/');
                const month = parseInt(parts[0], 10);
                const day = parseInt(parts[1], 10);
                const year = parseInt(parts[2], 10);
                
                // Validar año razonable
                if (year < 1900 || year > 2100) return false;
                
                // Verificar que la fecha sea real
                const date = new Date(year, month - 1, day);
                return date.getFullYear() === year &&
                       date.getMonth() === month - 1 &&
                       date.getDate() === day;
            }
            
            // Aplicar máscara mientras escribe
            dateField.addEventListener('input', function(e) {
                const cursorPos = this.selectionStart;
                const oldValue = this.value;
                const newValue = applyMask(this.value);
                
                this.value = newValue;
                
                // Mantener posición del cursor correcta
                let newCursorPos = cursorPos;
                if (newValue.length > oldValue.length) {
                    newCursorPos = cursorPos + 1;
                }
                this.setSelectionRange(newCursorPos, newCursorPos);
                
                // Solo feedback visual (sin alertas)
                if (newValue === '') {
                    this.classList.remove('valid');
                    this.style.color = '#00398b'; // Mantener color azul
                } else if (isValidDate(newValue)) {
                    this.classList.add('valid');
                    this.style.color = '#00398b'; // Mantener color azul
                } else {
                    this.classList.remove('valid');
                    this.style.color = '#00398b'; // Mantener color azul
                }
            });
            
            // Prevenir caracteres no numéricos
            dateField.addEventListener('keypress', function(e) {
                const char = String.fromCharCode(e.which);
                // Solo permitir números y algunas teclas especiales
                if (!/[0-9]/.test(char) && !e.ctrlKey && !e.metaKey && 
                    e.which !== 8 && e.which !== 9 && e.which !== 46) {
                    e.preventDefault();
                }
            });
            
            // Validación final al enviar (solo si quieres bloquear el envío)
            const form = dateField.closest('form');
            if (form) {
                form.addEventListener('submit', function(e) {
                    const value = dateField.value.trim();
                    // Solo bloquear si hay contenido pero es inválido
                    if (value !== '' && !isValidDate(value)) {
                        e.preventDefault();
                        dateField.focus();
                        return false;
                    }
                });
            }
        } else {
            console.log('Campo con ID 84179-text-3 no encontrado');
        }
    }, 500);
});

  
// assets/accordion-functionality.js
document.addEventListener('DOMContentLoaded', function() {
  initAddressAccordions();
  
  // Initialize on Shopify section refresh events
  document.addEventListener('shopify:section:load', function() {
    initAddressAccordions();
  });
  
  // Handle resize with debouncing to avoid excessive calls
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Only re-initialize on actual breakpoint changes
      const wasMobile = window.innerWidth <= 1280;
      initAddressAccordions(true);
      const isMobile = window.innerWidth <= 1280;
      
      // Only reinitialize if we crossed the breakpoint
      if (wasMobile !== isMobile) {
        initAddressAccordions();
      }
    }, 250);
  });
  
  function initAddressAccordions(isResizeEvent = false) {
    const accordionToggles = document.querySelectorAll('.address-showcase-section .accordion-toggle');
    
    accordionToggles.forEach(toggle => {
      const content = toggle.nextElementSibling;
      const isMobile = window.innerWidth <= 1280;
      
      // Preserve user-set state during scroll by checking for custom attributes we'll add
      const hasUserInteracted = toggle.hasAttribute('data-user-toggled');
      
      // If this is not a resize event or user hasn't interacted yet, set initial states
      if (!isResizeEvent || !hasUserInteracted) {
        if (isMobile) {
          // Mobile behavior - set based on mobile attribute
          if (content.hasAttribute('data-mobile-open')) {
            toggle.classList.add('active-mobile');
            content.style.display = 'block';
          } else {
            toggle.classList.remove('active-mobile');
            content.style.display = 'none';
          }
        } else {
          // Desktop behavior - set based on desktop attribute
          if (content.hasAttribute('data-desktop-open')) {
            toggle.classList.add('active-desktop');
            content.style.display = 'block';
          } else {
            toggle.classList.remove('active-desktop');
            content.style.display = 'none';
          }
        }
      }
    });
  }
  
  // Improved event listener for accordion clicks
  document.addEventListener('click', function(e) {
    const toggle = e.target.closest('.address-showcase-section .accordion-toggle');
    if (toggle) {
      e.preventDefault(); // Prevent any default behavior or event bubbling
      
      const content = toggle.nextElementSibling;
      const isMobile = window.innerWidth <= 1280;
      
      // Mark this toggle as user-interacted to preserve state
      toggle.setAttribute('data-user-toggled', 'true');
      
      // Toggle the appropriate class based on viewport
      if (isMobile) {
        toggle.classList.toggle('active-mobile');
        // Ensure desktop class doesn't interfere
        if (!content.hasAttribute('data-desktop-open')) {
          toggle.classList.remove('active-desktop');
        }
      } else {
        toggle.classList.toggle('active-desktop');
        // Ensure mobile class doesn't interfere
        if (!content.hasAttribute('data-mobile-open')) {
          toggle.classList.remove('active-mobile');
        }
      }
      
      // Set display based on the newly toggled state
      if ((isMobile && toggle.classList.contains('active-mobile')) || 
          (!isMobile && toggle.classList.contains('active-desktop'))) {
        content.style.display = 'block';
      } else {
        content.style.display = 'none';
      }
    }
  });
});
  
// HEADER
(function() {
  // Check if window width is within our target range
  function isInTargetWidthRange() {
    const windowWidth = window.innerWidth;
    return windowWidth >= 1100 && windowWidth <= 1600;
  }
  
  // Function to check and remove the class if needed
  function checkAndRemoveClass() {
    // Only remove the class if we're in the target width range
    if (isInTargetWidthRange()) {
      const header = document.querySelector('.site-header--compress');
      if (header) {
        header.classList.remove('site-header--compress');
        console.log('Removed site-header--compress class (width: ' + window.innerWidth + 'px)');
      }
    }
  }
  
  // Run immediately when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndRemoveClass);
  } else {
    checkAndRemoveClass();
  }
  
  // Set up a MutationObserver to detect when the class is added
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'class' &&
          mutation.target.classList.contains('site-header--compress') &&
          isInTargetWidthRange()) {
        mutation.target.classList.remove('site-header--compress');
      }
    });
  });
  
  // Also respond to window resize events
  window.addEventListener('resize', checkAndRemoveClass);
  
  // Start observing the header element once it's available
  function observeHeader() {
    const header = document.querySelector('.site-header') || document.querySelector('header');
    if (header) {
      observer.observe(header, { attributes: true });
      console.log('Now monitoring header for class changes');
    } else {
      // If header not found yet, try again in a moment
      setTimeout(observeHeader, 100);
    }
  }
  
  observeHeader();
})();


// Custom script to handle the chat opening
  // Check and open LiveChat based on URL hash
  function checkAndOpenLiveChat() {
    if (window.location.hash === '#livechat') {
      // Check if LiveChatWidget is loaded
      if (window.LiveChatWidget) {
        // Open the chat
        window.LiveChatWidget.call('maximize');
        
        // Clean the URL to allow reopening from the same link
        if (history.replaceState) {
          setTimeout(function() {
            history.replaceState(null, null, window.location.pathname + window.location.search);
          }, 500);
        } 
      } else {
        // LiveChat not loaded yet, wait and retry
        setTimeout(checkAndOpenLiveChat, 500);
      }
    }
  }
  
  // Listen for hash changes (for links with #livechat)
  window.addEventListener('hashchange', checkAndOpenLiveChat);
  
  // Check on initial page load
  document.addEventListener('DOMContentLoaded', checkAndOpenLiveChat);
 
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

// Solución mínima para galería móvil
document.addEventListener('DOMContentLoaded', function() {
    // Solo aplicar en móviles
    if (window.innerWidth <= 768) {
        console.log('🔧 Aplicando solución mínima para galería móvil...');
        
        // Simplemente agregar una clase CSS para identificar móviles
        const gallerySlider = document.querySelector('.product-gallery__media-slider');
        if (gallerySlider) {
            gallerySlider.classList.add('mobile-gallery-fix');
            console.log('✅ Clase mobile-gallery-fix agregada');
        }
    }
});
 